import React from 'react';

class UnauthedBetGames extends React.Component {
    _timeoutId = null;

    componentDidMount() {
        var _bt = _bt || [];
        // _bt.push(['server', 'https://game3.betgames.tv']);
        _bt.push(['server', 'https://gametv.fp.kz']);
        _bt.push(['partner', 'fairplay_kz']);
        _bt.push(['token', '-']);
        _bt.push(['language', 'ru']);
        _bt.push(['timezone', '6']);

        const script = document.createElement("script");

        script.type = "text/javascript";
        script.src = `https://game3.betgames.tv/design/client/js/betgames.js?ts=${Date.now()}'`;
        const parent = document.getElementById('betgames-wrapper');
        parent.appendChild(script);

        this._timeoutId = window.setTimeout(() => {
            window.BetGames.frame(_bt);
        }, 2000);
    }

    componentWillUnmount() {
        if (this._timeoutId !== null) {
            window.clearTimeout(this._timeoutId);
        }
    }

    render() {
        return (
            <div id="betgames_div_iframe" className='betgames-unauth'/>
        )
    }
}

export default UnauthedBetGames;


// WEBPACK FOOTER //
// ./js/sport-betting/components/betgames/UnauthedBetGames.jsx